export const DEFAULT_OUTPUT = "default";
